import { ExtraServiceWithTimeSlice } from '@numa-group/checkout-api';

export const serviceOffer = [
  {
    id: 'DE_FR_001-BFS',
    code: 'BFS',
    name: 'Breakfast',
    grossPrice: {
      amount: 36,
      currency: 'EUR',
    },
    count: 1,
    perNightBreakup: {
      unit: 'person',
      price: {
        amount: 12,
        currency: 'EUR',
      },
    },
    postNextDay: true,
    state: 'AVAILABLE',
    noOfExtraNights: 3,
    timeSlices: [
      {
        serviceDate: '2023-07-18',
        count: 1,
      },
      {
        serviceDate: '2023-07-19',
        count: 1,
      },
      {
        serviceDate: '2023-07-20',
        count: 1,
      },
    ],
    metadata: {
      description:
        '<p>Want to start your day with a taste of the neighbourhood? Treat yourself to a delicious breakfast at our local partner {partnerName}.<br /><br /></p>\n<ul>\n  <li>{partnerAddress}</li>\n  <li>{partnerDistance}-minute walk away</li>\n  <li>Weekdays open <span>from {WeekdayTimeFrom} to {WeekdayTimeTo} </span></li>\n  <li><span>Weekends open from {WeekendTimeFrom} to {WeekendTimeTo}</span></li>\n  <li><span>{menuOptions}</span><span><br /><br /></span></li>\n</ul>\n<p>The breakfast can be booked until 5pm the day before.&nbsp;</p>',
      name: 'Breakfast',
      photo: 'https://www.datocms-assets.com/49893/1660212748-7636cd0c-8cac-49de-903a-8105bc2f9f4e.jpeg',
      whereItWillBeVisible: ['reservation', 'extend-stay', 'extra-service'],
      breakfast: {
        type: 'partner',
        menuType: 'preselection',
        gallery: [],
        location: {
          name: 'Bar Shuka',
          googleMapLink:
            'https://www.google.de/maps/place/BAR+SHUKA+Restaurant+%26+Bar/@50.1095119,8.6612136,17z/data=!3m1!4b1!4m5!3m4!1s0x47bd09e1b437d737:0x18d69a0efda98ac1!8m2!3d50.1095119!4d8.6634023',
          eta: 2,
          directions:
            "<p>Our breakfast partner at Blau is Bar Shuka (Niddastra&szlig;e 56, 60329 Frankfurt am Main). Breakfast is available from 6:30 am-10:30 am on weekdays and from 7:30 am-11:30 am on weekends, and it's just a 2-min walk away. To get there, head left on B44 / D&uuml;sseldorfer Stra&szlig;e, turn left onto Niddastra&szlig;e, and Bar Shuka will be on your left. When you arrive, simply give your name and mention Blau to the staff before ordering, and they'll be happy to assist you!</p>",
          address: 'Niddastraße 56, 60329 Frankfurt am Main, Germany',
        },
        menus: [
          {
            option: 'food',
            title: 'Tel Aviv Morning',
            description:
              '<p>With the Tel Aviv Morning menu, you can enjoy:</p>\n<ul>\n<li>Shakshuka</li>\n<li>A Fruit Salad</li>\n<li>1 Pickled Cucumber</li>\n<li>1 Slice of Bread by choice</li>\n<li>Coffee or Tea by choice</li>\n<li>1 Fresh Juice by choice</li>\n</ul>',
            images: [],
          },
          {
            option: 'food',
            title: 'Haifa Dawn',
            description:
              '<p>With the Haifa Dawn menu, you can enjoy</p>\n<ul>\n<li>Bread by choice</li>\n<li>Bircherm&uuml;sli</li>\n<li>Coffee or Tea by choice</li>\n<li>1 Fresh Juice by choice&nbsp;</li>\n</ul>',
            images: [],
          },
          {
            option: 'food',
            title: 'Isreal Good Start',
            description:
              '<p>With the Isreal Good Start menu, you can enjoy:</p>\n<ul>\n<li>1 Egg by Choice</li>\n<li>Small Coco-Chia Pudding</li>\n<li>1 Slice of Bread by choice</li>\n<li>Coffee or Tea by choice</li>\n<li>1 Fresh Juice by choice&nbsp;</li>\n</ul>',
            images: [],
          },
          {
            option: 'food',
            title: 'Jerusalem Kiss',
            description:
              '<p>With the Jerusalem Kiss menu, you can enjoy:</p>\n<ul>\n<li>Challah Frenchtoast</li>\n<li>Small Coco-Chia Pudding</li>\n<li>Coffee or Tea by choice</li>\n<li>1 Fresh Juice by choice&nbsp;</li>\n</ul>',
            images: [],
          },
          {
            option: 'food',
            title: 'Nazareth Healthy',
            description:
              '<p>With the Nazareth Healthy menu, you can enjoy:</p>\n<ul>\n<li>A Fruit Salad</li>\n<li>1 Coffee or Tea by choice</li>\n<li>1 Strawberry-Kefir</li>\n<li>1 Spelt Croissant</li>\n<li>Jam</li>\n</ul>',
            images: [],
          },
        ],
        photo: 'https://www.datocms-assets.com/49893/1660212748-7636cd0c-8cac-49de-903a-8105bc2f9f4e.jpeg',
        hourAvailability: {
          deliveryFrom: null,
          deliveryTo: null,
          from: '2022-01-01T05:30:00+01:00',
          to: '2022-01-01T09:30:00+01:00',
          sundayFrom: '2022-01-01T06:30:00+01:00',
          sundayTo: '2022-01-01T10:30:00+01:00',
          saturdayFrom: '2022-01-01T06:30:00+01:00',
          saturdayTo: '2022-01-01T10:30:00+01:00',
        },
      },
    },
  },
] as unknown as ExtraServiceWithTimeSlice[];
